<template>
  <div id="menu-items" class="pb3 pt2 md-py4 px2 md-px4">
    <div class="menu-content" v-html="menu"></div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {

  name: 'MenuItems',

  data () {
    return {}
  },
  computed: {
    ...mapState([
      'menu'
    ])
  },
  methods: {
    getMenuItems: function (group) {
      return this.menuItems.filter(item => item.Group === group)
    }
  }
}
</script>

<style lang="css">
  #menu-items {
    color: white;
    background: rgb(40,40,40);
    font-size: var(--fs-m);
    line-height: var(--lh-m);
    min-height: 100vh;

    h1 {
      margin-top: 2em;
    }

    h1, h2 {
      text-transform: uppercase;
      margin-bottom: 0.5em;
    }

    ul {
      margin-left: 1em;
      margin-top: 0;
      padding: 0;
      list-style: none;
      li {
        color: white;
        margin-bottom: 0.5em;
      }
    }

    em, .menu-item-description {
      display: block;
      margin-bottom: 0.5em;
      width: 70%;
      opacity: 0.3;
    }

    .menu-item-title {
      padding-right: 3em;
    }

    .menu-item-price {
      white-space: nowrap;
    }
  }
</style>
